import type { ColorValue, StyleProp, ViewStyle } from 'react-native';

import { getStyleSheet } from './style-sheet-memo';

export const bc = (backgroundColor: string): StyleProp<ViewStyle> =>
  getStyleSheet({ backgroundColor });

export const borderColor = (
  borderColor:
    | string
    | {
        borderLeftColor?: ColorValue;
        borderRightColor?: ColorValue;
        borderTopColor?: ColorValue;
        borderBottomColor?: ColorValue;
      }
): StyleProp<ViewStyle> => {
  if (typeof borderColor === 'object') {
    const {
      borderLeftColor,
      borderRightColor,
      borderTopColor,
      borderBottomColor,
    } = borderColor;
    return getStyleSheet({
      borderLeftColor,
      borderRightColor,
      borderTopColor,
      borderBottomColor,
    });
  }

  return getStyleSheet({ borderColor });
};

export const shadowColor = (shadowColor: ColorValue): StyleProp<ViewStyle> =>
  getStyleSheet({ shadowColor });

export const color = (color: string): StyleProp<ViewStyle> =>
  getStyleSheet({ color });
